import useController from '@common/hooks/useController'

// Native / mobile-web shim — read the QR controller state from the in-process
// ControllerStore.
//
// The web variant subscribes with `useControllerState('QrHardwareController')`,
// which listens for an eventBus event NAMED AFTER THE CONTROLLER. That event
// only exists in the extension (the MV3 port messenger re-emits per controller).
// Off-extension, controller state arrives from the worker as a single generic
// `ctrlUpdate` event (see WebViewWorker `sendToReactEvent`) that only feeds
// `ControllerStoreProvider` — so the web hook returned `{}` forever and
// `currentRequest` / `signingStep` never reached the UI. `Modals` renders the
// QR sheet only when both are set, so a Keystone/Keycard sign silently hung on
// "Sending…" with no QR prompt.
//
// Corroboration: 26 of the 27 `use*ControllerState` hooks under `src/web/hooks/`
// already ship a `.native` shim for exactly this reason. This one was the
// omission. Confirmed on the deployed dev build: with this shim the Keystone
// sheet renders and signing completes.
export default function useQrHardwareControllerState(): any {
  const { state } = useController('QrHardwareController' as any)

  return (state || {}) as any
}
